webpackJsonp([2],{

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__convertTreeToSchema__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__convertTreeToSchema__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__convertSchemaToTree__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__convertSchemaToTree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__firebase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repository_firebase__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__repository_firebase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__componentData__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__componentData__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__treeData__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__treeData__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menuData__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__menuData__["a"]; });








/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__allOf__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__anyOf__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boolean__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__definitions__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dependencies__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dependencyItem__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enum__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__integer__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__items__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__jsonSchema__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__not__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__null__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__number__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__object__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__oneOf__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__properties__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ref__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__required__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__string__ = __webpack_require__(92);





















/* harmony default export */ __webpack_exports__["a"] = ({
  AllOfComponent: __WEBPACK_IMPORTED_MODULE_0__allOf__["a" /* default */],
  AnyOfComponent: __WEBPACK_IMPORTED_MODULE_1__anyOf__["a" /* default */],
  ArrayComponent: __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */],
  BooleanComponent: __WEBPACK_IMPORTED_MODULE_3__boolean__["a" /* default */],
  DefinitionsComponent: __WEBPACK_IMPORTED_MODULE_4__definitions__["a" /* default */],
  DependenciesComponent: __WEBPACK_IMPORTED_MODULE_5__dependencies__["a" /* default */],
  DependencyItemComponent: __WEBPACK_IMPORTED_MODULE_6__dependencyItem__["a" /* default */],
  EnumComponent: __WEBPACK_IMPORTED_MODULE_7__enum__["a" /* default */],
  IntegerComponent: __WEBPACK_IMPORTED_MODULE_8__integer__["a" /* default */],
  ItemsComponent: __WEBPACK_IMPORTED_MODULE_9__items__["a" /* default */],
  JsonSchemaComponent: __WEBPACK_IMPORTED_MODULE_10__jsonSchema__["a" /* default */],
  NotComponent: __WEBPACK_IMPORTED_MODULE_11__not__["a" /* default */],
  NullComponent: __WEBPACK_IMPORTED_MODULE_12__null__["a" /* default */],
  NumberComponent: __WEBPACK_IMPORTED_MODULE_13__number__["a" /* default */],
  ObjectComponent: __WEBPACK_IMPORTED_MODULE_14__object__["a" /* default */],
  OneOfComponent: __WEBPACK_IMPORTED_MODULE_15__oneOf__["a" /* default */],
  PropertiesComponent: __WEBPACK_IMPORTED_MODULE_16__properties__["a" /* default */],
  RefComponent: __WEBPACK_IMPORTED_MODULE_17__ref__["a" /* default */],
  RequiredComponent: __WEBPACK_IMPORTED_MODULE_18__required__["a" /* default */],
  StringComponent: __WEBPACK_IMPORTED_MODULE_19__string__["a" /* default */]
});

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = UserNotSignInError;
/* unused harmony export Authentication */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authentication; });
/* unused harmony export Storage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Database; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);








var config = {
  apiKey: 'AIzaSyD1BLDRwuKdS_R3xOF3hNgYxgJ9HP9lC74',
  authDomain: 'json-schema-editor.firebaseapp.com',
  databaseURL: 'https://json-schema-editor.firebaseio.com',
  projectId: 'json-schema-editor',
  storageBucket: 'json-schema-editor.appspot.com',
  messagingSenderId: '84857119510'
};
__WEBPACK_IMPORTED_MODULE_6_firebase__["initializeApp"](config);

function UserNotSignInError(message) {
  this.name = 'UserNotSignInError';
  this.message = message || 'No sign in user.';
  this.stack = new Error().stack;
}
UserNotSignInError.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(Error.prototype);
UserNotSignInError.prototype.constructor = UserNotSignInError;

var Authentication = function () {
  function Authentication() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Authentication);

    this.service = __WEBPACK_IMPORTED_MODULE_6_firebase__["auth"]();
    this.currentUser = null;
    this.callbacks = [];
    this.service.onAuthStateChanged(function (user) {
      _this.currentUser = user;
      _this.callbacks.forEach(function (callback) {
        callback(user);
      });
    });
    this.options = {
      requireVerifyEmail: false,
      sendVerifyEmailExplicitly: true,
      requireOldPassword: false
    };
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Authentication, [{
    key: 'addListener',
    value: function addListener(callback) {
      this.callbacks.push(callback);
    }
  }, {
    key: 'removeListener',
    value: function removeListener(callback) {
      var idx = this.callbacks.indexOf(callback);
      if (idx >= 0) this.callbacks.splice(idx, 1);
    }
  }, {
    key: 'signUp',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(email, password) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this2.service.createUserWithEmailAndPassword(email, password).then(function (user) {
                    resolve(user);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signUp(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return signUp;
    }()
  }, {
    key: 'sendVerificationEmail',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.currentUser) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this3.currentUser.sendEmailVerification().then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 4:
                throw new UserNotSignInError();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendVerificationEmail() {
        return _ref2.apply(this, arguments);
      }

      return sendVerificationEmail;
    }()
  }, {
    key: 'verifyEmail',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(code) {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this4.service.applyActionCode(code).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function verifyEmail(_x3) {
        return _ref3.apply(this, arguments);
      }

      return verifyEmail;
    }()
  }, {
    key: 'signIn',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(email, password) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this5.service.signInWithEmailAndPassword(email, password).then(function (user) {
                    resolve(user);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function signIn(_x4, _x5) {
        return _ref4.apply(this, arguments);
      }

      return signIn;
    }()
  }, {
    key: 'changePassword',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(newPassword) {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.currentUser) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this6.currentUser.updatePassword(newPassword).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 4:
                throw new UserNotSignInError();

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function changePassword(_x6) {
        return _ref5.apply(this, arguments);
      }

      return changePassword;
    }()
  }, {
    key: 'resetPassword',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(email) {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this7.service.sendPasswordResetEmail(email).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function resetPassword(_x7) {
        return _ref6.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: 'confirmPasswordReset',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(code, newPassword) {
        var _this8 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this8.service.confirmPasswordReset(code, newPassword).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function confirmPasswordReset(_x8, _x9) {
        return _ref7.apply(this, arguments);
      }

      return confirmPasswordReset;
    }()
  }, {
    key: 'deleteUser',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _this9 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.currentUser) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this9.currentUser.delete().then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 4:
                throw new UserNotSignInError();

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteUser() {
        return _ref8.apply(this, arguments);
      }

      return deleteUser;
    }()
  }, {
    key: 'signOut',
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var _this10 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this10.service.signOut().then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function signOut() {
        return _ref9.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: 'retrieveCurrentUser',
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _this11 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this11.currentUser = _this11.service.currentUser;
                  if (_this11.currentUser) {
                    resolve(_this11.currentUser);
                  } else {
                    reject(new UserNotSignInError());
                  }
                }));

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function retrieveCurrentUser() {
        return _ref10.apply(this, arguments);
      }

      return retrieveCurrentUser;
    }()
  }]);

  return Authentication;
}();

var authentication = new Authentication();

var Storage = function Storage() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Storage);

  this.service = __WEBPACK_IMPORTED_MODULE_6_firebase__["storage"]();
};

var Database = function () {
  function Database() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Database);

    this.service = __WEBPACK_IMPORTED_MODULE_6_firebase__["database"]();
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Database, [{
    key: 'readSnapshot',
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(reference) {
        var _this12 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this12.service.ref(reference).orderByKey().once('value').then(function (snapshot) {
                    resolve(snapshot);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function readSnapshot(_x10) {
        return _ref11.apply(this, arguments);
      }

      return readSnapshot;
    }()
  }, {
    key: 'readValue',
    value: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(reference) {
        var _this13 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this13.service.ref(reference).orderByKey().once('value').then(function (snapshot) {
                    resolve(snapshot.val());
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function readValue(_x11) {
        return _ref12.apply(this, arguments);
      }

      return readValue;
    }()
  }, {
    key: 'list',
    value: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(reference) {
        var _this14 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this14.service.ref(reference).orderByKey().once('value').then(function (snapshot) {
                    var list = [];
                    snapshot.forEach(function (child) {
                      list.push(child.key);
                    });
                    resolve(list);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function list(_x12) {
        return _ref13.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'write',
    value: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(reference, data) {
        var _this15 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this15.service.ref(reference).set(data).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function write(_x13, _x14) {
        return _ref14.apply(this, arguments);
      }

      return write;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(reference) {
        var _this16 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this16.service.ref(reference).remove().then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function _delete(_x15) {
        return _ref15.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return Database;
}();

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(707),
  /* scopeId */
  "data-v-16055fcb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_icons_css_material_icons_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_icons_css_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_icons_css_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Nav__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Nav__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('default', {
  primary: 'blue'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#nav',
  template: '<Nav/>',
  components: { Nav: __WEBPACK_IMPORTED_MODULE_4__Nav___default.a }
});

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_json_schema_editor__ = __webpack_require__(18);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nav',
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__components_json_schema_editor__["a" /* authentication */].retrieveCurrentUser();

            case 3:
              _context.next = 7;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

            case 7:
              _this.isSignIn = __WEBPACK_IMPORTED_MODULE_2__components_json_schema_editor__["a" /* authentication */].currentUser !== null;
              __WEBPACK_IMPORTED_MODULE_2__components_json_schema_editor__["a" /* authentication */].addListener(_this.authChanged);
              _this.$root.$on('accountStatus', function () {
                _this.isSignIn = __WEBPACK_IMPORTED_MODULE_2__components_json_schema_editor__["a" /* authentication */].currentUser !== null;
              });

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5]]);
    }))();
  },
  data: function data() {
    return {
      isSignIn: false,
      active: 'active'
    };
  },

  methods: {
    authChanged: function authChanged(user) {
      this.isSignIn = user !== null;
    },
    isPath: function isPath(path) {
      return window.location.pathname === path;
    },
    home: function home() {
      if (this.isSignIn) {
        window.location.href = '/editor.html';
      } else {
        window.location.href = '/index.html';
      }
    },
    about: function about() {
      window.location.href = '/index.html';
    },
    guide: function guide() {
      window.location.href = '/guide.html';
    },
    editor: function editor() {
      window.location.href = '/editor.html';
    },
    jsonEditor: function jsonEditor() {
      window.open('https://json-editor.tangramjs.com', '_blank');
    },
    github: function github() {
      window.open('https://github.com/tangram-js/json-schema-editor', '_blank');
    },
    signIn: function signIn() {
      window.location.href = '/editor.html#/signIn';
    },
    signUp: function signUp() {
      window.location.href = '/editor.html#/signUp';
    },
    changePassword: function changePassword() {
      window.location.href = '/editor.html#/changePassword';
    },
    signOut: function signOut() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__components_json_schema_editor__["a" /* authentication */].signOut();

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

              case 7:
                _this2.$nextTick(function () {
                  console.log('reload');
                  window.location.reload();
                });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5]]);
      }))();
    },
    deleteAccount: function deleteAccount() {
      this.$refs.deleteAccountDialog.open();
    },
    deleteAccountCanceled: function deleteAccountCanceled() {
      this.$refs.deleteAccountDialog.close();
    },
    deleteAccountConfirmed: function deleteAccountConfirmed() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__components_json_schema_editor__["b" /* repository */].deleteAllSchemas();

              case 3:
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__components_json_schema_editor__["a" /* authentication */].deleteUser();

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

              case 9:
                _this3.$refs.deleteAccountDialog.close();
                _this3.$nextTick(function () {
                  window.location.reload();
                });

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    }
  }
});

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = convertTreeToSchema;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function clone(source) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(source));
}

function convertTypeToSchema(node) {
  var schema = clone(node.value);
  if (node.children && node.children.length > 0) {
    schema.enum = clone(node.children[0].value.enum);
  }
  return schema;
}

function convertObjectToSchema(node) {
  var schema = clone(node.value);
  node.children.forEach(function (child) {
    switch (child.type) {
      case 'properties':
        schema.properties = convertPropertiesToSchema(child);
        break;
      case 'required':
        schema.required = clone(child.value);
        break;
      case 'dependencies':
        schema.dependencies = convertDependenciesToSchema(child);
        break;
      case 'enum':
        schema.enum = clone(child.value.enum);
        break;
    }
  });
  return schema;
}

function convertArrayToSchema(node) {
  var schema = clone(node.value);
  if (node.children.length > 0) {
    var child = node.children[0];
    switch (child.type) {
      case 'jsonSchema':
        schema.items = convertTreeToSchema(child);
        break;
      case 'string':
      case 'integer':
      case 'number':
      case 'boolean':
      case 'null':
      case 'enum':
      case 'ref':
        schema.items = convertTypeToSchema(child);
        break;
      case 'object':
        schema.items = convertObjectToSchema(child);
        break;
      case 'array':
        schema.items = convertArrayToSchema(child);
        break;
      case 'allOf':
      case 'anyOf':
      case 'oneOf':
      case 'not':
        schema.items = convertOptionToSchema(child);
        break;
      case 'items':
        schema.items = convertItemsToSchema(child);
        break;
    }
  }
  return schema;
}

function convertPropertiesToSchema(node) {
  var schema = {};
  node.children.forEach(function (child) {
    switch (child.type) {
      case 'jsonSchema':
        schema[child.name] = convertTreeToSchema(child);
        break;
      case 'string':
      case 'integer':
      case 'number':
      case 'boolean':
      case 'null':
      case 'enum':
      case 'ref':
        schema[child.name] = convertTypeToSchema(child);
        break;
      case 'object':
        schema[child.name] = convertObjectToSchema(child);
        break;
      case 'array':
        schema[child.name] = convertArrayToSchema(child);
        break;
      case 'allOf':
      case 'anyOf':
      case 'oneOf':
      case 'not':
        schema[child.name] = convertOptionToSchema(child);
        break;
    }
  });
  return schema;
}

function convertDependenciesToSchema(node) {
  var schema = {};
  node.children.forEach(function (child) {
    schema[child.name] = clone(child.value);
  });
  return schema;
}

function convertItemsToSchema(node) {
  var schema = [];
  node.children.forEach(function (child) {
    switch (child.type) {
      case 'jsonSchema':
        schema.push(convertTreeToSchema(child));
        break;
      case 'string':
      case 'integer':
      case 'number':
      case 'boolean':
      case 'null':
      case 'enum':
      case 'ref':
        schema.push(convertTypeToSchema(child));
        break;
      case 'object':
        schema.push(convertObjectToSchema(child));
        break;
      case 'array':
        schema.push(convertArrayToSchema(child));
        break;
      case 'allOf':
      case 'anyOf':
      case 'oneOf':
      case 'not':
        schema.push(convertOptionToSchema(child));
        break;
    }
  });
  return schema;
}

function convertOptionToSchema(node) {
  var schema = {};
  schema[node.type] = [];
  var list = schema[node.type];
  node.children.forEach(function (child) {
    switch (child.type) {
      case 'jsonSchema':
        list.push(convertTreeToSchema(child));
        break;
      case 'string':
      case 'integer':
      case 'number':
      case 'boolean':
      case 'null':
      case 'enum':
      case 'ref':
        list.push(convertTypeToSchema(child));
        break;
      case 'object':
        list.push(convertObjectToSchema(child));
        break;
      case 'array':
        list.push(convertArrayToSchema(child));
        break;
      case 'allOf':
      case 'anyOf':
      case 'oneOf':
      case 'not':
        list.push(convertOptionToSchema(child));
        break;
    }
  });
  return schema;
}

function convertDefinitionsToSchema(node) {
  var schema = {};
  node.children.forEach(function (child) {
    switch (child.type) {
      case 'jsonSchema':
        schema[child.name] = convertTreeToSchema(child);
        break;
      case 'string':
      case 'integer':
      case 'number':
      case 'boolean':
      case 'null':
      case 'enum':
      case 'ref':
        schema[child.name] = convertTypeToSchema(child);
        break;
      case 'object':
        schema[child.name] = convertObjectToSchema(child);
        break;
      case 'array':
        schema[child.name] = convertArrayToSchema(child);
        break;
      case 'allOf':
      case 'anyOf':
      case 'oneOf':
      case 'not':
        schema[child.name] = convertOptionToSchema(child);
        break;
    }
  });
  return schema;
}

function convertTreeToSchema(tree) {
  var schema = {};
  if (tree.children.length > 0) {
    var child = tree.children[0];
    switch (child.type) {
      case 'jsonSchema':
        schema = convertTreeToSchema(child);
        break;
      case 'string':
      case 'integer':
      case 'number':
      case 'boolean':
      case 'null':
      case 'enum':
        schema = convertTypeToSchema(child);
        break;
      case 'object':
        schema = convertObjectToSchema(child);
        break;
      case 'array':
        schema = convertArrayToSchema(child);
        break;
      case 'allOf':
      case 'anyOf':
      case 'oneOf':
      case 'not':
        schema = convertOptionToSchema(child);
        break;
      case 'definitions':
        schema.definitions = convertDefinitionsToSchema(child);
        break;
    }
  }
  if (!tree.parent) schema.title = tree.name;
  if (tree.value.description) schema.description = tree.value.description;
  return schema;
}

/* harmony default export */ __webpack_exports__["a"] = (convertTreeToSchema);

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('h3', {
    staticClass: "md-title title",
    on: {
      "click": _vm.home
    }
  }, [_vm._v("JSON Schema Editor")]), _vm._v(" "), _c('md-button', {
    class: [_vm.isPath('/index.html') || _vm.isPath('/') ? _vm.active : ''],
    nativeOn: {
      "click": function($event) {
        return _vm.about($event)
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('md-button', {
    class: [_vm.isPath('/guide.html') ? _vm.active : ''],
    nativeOn: {
      "click": function($event) {
        return _vm.guide($event)
      }
    }
  }, [_vm._v("Guide")]), _vm._v(" "), _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.editor($event)
      }
    }
  }, [_vm._v("Editor")]), _vm._v(" "), _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.jsonEditor($event)
      }
    }
  }, [_vm._v("JSON Editor")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.github($event)
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "md-iconset": "fa fa-github"
    }
  })], 1), _vm._v(" "), (!_vm.isSignIn) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.signIn($event)
      }
    }
  }, [_vm._v("Sign In")]) : _vm._e(), _vm._v(" "), (!_vm.isSignIn) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.signUp($event)
      }
    }
  }, [_vm._v("Sign Up")]) : _vm._e(), _vm._v(" "), (_vm.isSignIn) ? _c('md-menu', {
    attrs: {
      "md-align-trigger": ""
    }
  }, [_c('md-button', {
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_vm._v("My Account")]), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign Out")]), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changePassword($event)
      }
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAccount($event)
      }
    }
  }, [_vm._v("Delete Account")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-dialog', {
    ref: "deleteAccountDialog"
  }, [_c('md-dialog-title', [_vm._v("Delete Account")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      Are you sure to delete your account?"), _c('br'), _vm._v("\n      All your stored schemas would be lost!\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAccountCanceled($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAccountConfirmed($event)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(24);


var componentData = [new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].StringComponent('Type string'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].IntegerComponent('Type integer'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].NumberComponent('Type number'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].BooleanComponent('Type boolean'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].ObjectComponent('Type object'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].ArrayComponent('Type array'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].NullComponent('Type null'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].PropertiesComponent('List properties of object'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].RequiredComponent('List required properties of object'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].DependenciesComponent('List dependencies between properties'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].DependencyItemComponent('List of properties which specific property depend on'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].ItemsComponent('List type of each item'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].EnumComponent('List of valid values'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].AllOfComponent('Data must be valid against all of the given subschemas'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].AnyOfComponent('Data must be valid against any of the given subschemas'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].OneOfComponent('Data must be valid against exactly one of the given subschemas'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].NotComponent('Data must not be valid against all of the given subschemas'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].RefComponent('Reference to external schema'), new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].DefinitionsComponent('Definitions of reusable schema')];

/* unused harmony default export */ var _unused_webpack_default_export = (componentData);

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AllOfComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var AllOfComponent = function AllOfComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AllOfComponent);

  this.type = 'allOf';
  this.tooltip = tooltip;
  this.icon = 'options';
  this.value = undefined;
  this.valueSchema = undefined;
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'ref':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList() {
      return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref'];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (AllOfComponent);

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AnyOfComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var AnyOfComponent = function AnyOfComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnyOfComponent);

  this.type = 'anyOf';
  this.tooltip = tooltip;
  this.icon = 'options';
  this.value = undefined;
  this.valueSchema = undefined;
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'ref':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList() {
      return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref'];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (AnyOfComponent);

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ArrayComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var ArrayComponent = function ArrayComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ArrayComponent);

  this.type = 'array';
  this.tooltip = tooltip;
  this.icon = 'type';
  this.value = {
    type: 'array'
  };

  this.valueSchema = {
    type: 'object',
    properties: {
      additionalItems: {
        type: 'boolean'
      },
      minItems: {
        type: 'integer',
        minimum: 0
      },
      maxItems: {
        type: 'integer',
        minimum: 0
      },
      uniqueItems: {
        type: 'boolean'
      }
    }
  };
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      if (dest.children.length > 0) return false;

      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'ref':
        case 'items':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList(dest) {
      return dest.children.length === 0 ? ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref', 'items'] : [];
    },
    beforeAppend: function beforeAppend(dest, node) {
      if (node.type !== 'items') node.name = 'items';
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (ArrayComponent);

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BooleanComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var BooleanComponent = function BooleanComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BooleanComponent);

  this.type = 'boolean';
  this.tooltip = tooltip;
  this.icon = 'type';
  this.value = {
    type: 'boolean'
  };
  this.valueSchema = {
    type: 'object'
  };
  this.editable = false;
  this.funcs = {
    acceptList: function acceptList() {
      return [];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (BooleanComponent);

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefinitionsComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var DefinitionsComponent = function DefinitionsComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DefinitionsComponent);

  this.type = 'definitions';
  this.tooltip = tooltip;
  this.icon = 'definitions';
  this.value = undefined;
  this.valueSchema = undefined;
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'ref':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList() {
      return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref'];
    },
    beforeAppend: function beforeAppend(dest, node) {
      node.name = 'definition';
      node.editable = true;
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (DefinitionsComponent);

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DependenciesComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var DependenciesComponent = function DependenciesComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DependenciesComponent);

  this.type = 'dependencies';
  this.tooltip = tooltip;
  this.icon = 'dependencies';
  this.value = undefined;
  this.valueSchema = undefined;
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      return node.type === 'dependencyItem';
    },
    acceptList: function acceptList() {
      return ['dependencyItem'];
    },
    beforeAppend: function beforeAppend(dest, node) {
      node.name = '';
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (DependenciesComponent);

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DependencyItemComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var DependencyItemComponent = function DependencyItemComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DependencyItemComponent);

  this.type = 'dependencyItem';
  this.tooltip = tooltip;
  this.icon = 'dependency';
  this.value = [];
  this.valueSchema = {
    type: 'array',
    items: {
      type: 'string',
      enum: []
    },
    additionalItems: false,
    uniqueItems: true
  };
  this.editable = false;
  this.funcs = {
    acceptList: function acceptList() {
      return [];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (DependencyItemComponent);

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EnumComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var EnumComponent = function EnumComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, EnumComponent);

  this.type = 'enum';
  this.tooltip = tooltip;
  this.icon = 'enum';
  this.value = {
    enum: []
  };
  this.valueSchema = {
    type: 'object',
    properties: {
      enum: {
        type: 'array'
      }
    },
    required: ['enum'],
    additionalProperties: false
  };
  this.editable = false;
  this.funcs = {
    acceptList: function acceptList() {
      return [];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (EnumComponent);

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IntegerComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var IntegerComponent = function IntegerComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IntegerComponent);

  this.type = 'integer';
  this.tooltip = tooltip;
  this.icon = 'type';
  this.value = {
    type: 'integer'
  };
  this.valueSchema = {
    type: 'object',
    properties: {
      multipleOf: {
        type: 'integer',
        minimum: 1
      },
      minimum: {
        type: 'integer'
      },
      excludeMinimum: {
        type: 'integer'
      },
      maximum: {
        type: 'integer'
      },
      excludeMaximum: {
        type: 'integer'
      }
    }
  };
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      if (node.type === 'enum') {
        return true;
      } else {
        return false;
      }
    },
    acceptList: function acceptList() {
      return ['enum'];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (IntegerComponent);

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ItemsComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var ItemsComponent = function ItemsComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ItemsComponent);

  this.type = 'items';
  this.tooltip = tooltip;
  this.icon = 'items';
  this.value = undefined;
  this.valueSchema = undefined;
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'ref':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList() {
      return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref'];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (ItemsComponent);

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export JsonSchemaComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var JsonSchemaComponent = function JsonSchemaComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, JsonSchemaComponent);

  this.type = 'jsonSchema';
  this.name = 'schema';
  this.tooltip = tooltip;
  this.icon = 'jsonSchema';
  this.value = {};
  this.valueSchema = {
    type: 'object',
    properties: {
      description: {
        type: 'string',
        format: 'textarea'
      }
    }
  };
  this.children = [];
  this.editable = true;
  this.funcs = {
    accept: function accept(dest, node) {
      if (dest.children.length > 0) {
        if (dest.children.length > 1) return false;
        if (dest.children[0].type === 'definitions' && node.type === 'definitions' || dest.children[0].type !== 'definitions' && node.type !== 'definitions') return false;
      }

      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'definitions':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList(dest) {
      if (dest.children.length > 0) {
        if (dest.children.length > 1) return [];
        if (dest.children[0].type === 'definitions') {
          return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref'];
        } else {
          return ['definitions'];
        }
      }
      return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref', 'definitions'];
    },
    dropped: function dropped(dest, node) {}
  };
};

/* harmony default export */ __webpack_exports__["a"] = (JsonSchemaComponent);

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var NotComponent = function NotComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NotComponent);

  this.type = 'not';
  this.tooltip = tooltip;
  this.icon = 'not';
  this.value = undefined;
  this.valueSchema = undefined;
  this.editable = false;
  this.children = [];
  this.funcs = {
    accept: function accept(dest, node) {
      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'ref':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList() {
      return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref'];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (NotComponent);

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NullComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var NullComponent = function NullComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NullComponent);

  this.type = 'null';
  this.tooltip = tooltip;
  this.icon = 'type';
  this.value = {
    type: 'null'
  };
  this.valueSchema = {
    type: 'object'
  };
  this.editable = false;
  this.funcs = {
    acceptList: function acceptList() {
      return [];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (NullComponent);

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NumberComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var NumberComponent = function NumberComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NumberComponent);

  this.type = 'number';
  this.tooltip = tooltip;
  this.icon = 'type';
  this.value = {
    type: 'number'
  };
  this.valueSchema = {
    type: 'object',
    properties: {
      multipleOf: {
        type: 'number',
        minimum: 0,
        excludeMinimum: true
      },
      minimum: {
        type: 'number'
      },
      excludeMinimum: {
        type: 'number'
      },
      maximum: {
        type: 'number'
      },
      excludeMaximum: {
        type: 'number'
      }
    }
  };
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      if (node.type === 'enum') {
        return true;
      } else {
        return false;
      }
    },
    acceptList: function acceptList() {
      return ['enum'];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (NumberComponent);

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ObjectComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);



function typeExist(children, type) {
  var result = false;
  children.forEach(function (child) {
    if (child.type === type) result = true;
  });
  return result;
}

var ObjectComponent = function ObjectComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ObjectComponent);

  this.type = 'object';
  this.tooltip = tooltip;
  this.icon = 'type';
  this.value = {
    type: 'object'
  };

  this.valueSchema = {
    type: 'object',
    properties: {
      additionalProperties: {
        type: 'boolean'
      },
      minProperties: {
        type: 'integer',
        minimum: 0
      },
      maxProperties: {
        type: 'integer',
        minimum: 0
      }
    }
  };
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      if (typeExist(dest.children, node.type)) return false;

      if (node.type === 'required') {
        return typeExist(dest.children, 'properties');
      }

      if (node.type === 'dependencies') {
        return typeExist(dest.children, 'properties');
      }

      switch (node.type) {
        case 'properties':
        case 'required':
        case 'dependencies':
        case 'enum':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList(dest) {
      var result = [];
      if (!typeExist(dest.children, 'properties')) {
        result.push('properties');
      } else {
        if (!typeExist(dest.children, 'required')) result.push('required');
        if (!typeExist(dest.children, 'dependencies')) result.push('dependencies');
      }
      if (!typeExist(dest.children, 'enum')) result.push('enum');
      return result;
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (ObjectComponent);

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OneOfComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var OneOfComponent = function OneOfComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OneOfComponent);

  this.type = 'oneOf';
  this.tooltip = tooltip;
  this.icon = 'options';
  this.value = undefined;
  this.valueSchema = undefined;
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'ref':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList() {
      return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref'];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (OneOfComponent);

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PropertiesComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var PropertiesComponent = function PropertiesComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PropertiesComponent);

  this.type = 'properties';
  this.tooltip = tooltip;
  this.icon = 'properties';
  this.value = undefined;
  this.valueSchema = undefined;
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      switch (node.type) {
        case 'jsonSchema':
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'object':
        case 'array':
        case 'null':
        case 'enum':
        case 'allOf':
        case 'anyOf':
        case 'oneOf':
        case 'not':
        case 'ref':
          return true;
        default:
          return false;
      }
    },
    acceptList: function acceptList() {
      return ['string', 'integer', 'number', 'boolean', 'object', 'array', 'null', 'enum', 'allOf', 'anyOf', 'oneOf', 'not', 'ref'];
    },
    beforeAppend: function beforeAppend(dest, node) {
      node.name = 'prop';
      node.editable = true;
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (PropertiesComponent);

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RefComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var RefComponent = function RefComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RefComponent);

  this.type = 'ref';
  this.tooltip = tooltip;
  this.icon = 'ref';
  this.value = {
    '$ref': ''
  };
  this.valueSchema = {
    type: 'object',
    properties: {
      '$ref': {
        type: 'string'
      }
    },
    required: ['$ref'],
    additionalProperties: false
  };
  this.editable = false;
  this.funcs = {
    acceptList: function acceptList() {
      return [];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (RefComponent);

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RequiredComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var RequiredComponent = function RequiredComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RequiredComponent);

  this.type = 'required';
  this.tooltip = tooltip;
  this.icon = 'required';
  this.value = [];
  this.valueSchema = {
    type: 'array',
    items: {
      type: 'string',
      enum: []
    }
  };
  this.editable = false;
  this.funcs = {
    acceptList: function acceptList() {
      return [];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (RequiredComponent);

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StringComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var StringComponent = function StringComponent(tooltip) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StringComponent);

  this.type = 'string';
  this.tooltip = tooltip;
  this.icon = 'type';
  this.value = {
    type: 'string'
  };
  this.valueSchema = {
    type: 'object',
    properties: {
      minLength: {
        type: 'integer',
        minimum: 0
      },
      maxLength: {
        type: 'integer',
        minimum: 0
      },
      pattern: {
        type: 'string'
      },
      format: {
        type: 'string'
      }
    }
  };
  this.children = [];
  this.editable = false;
  this.funcs = {
    accept: function accept(dest, node) {
      if (node.type === 'enum') {
        return true;
      } else {
        return false;
      }
    },
    acceptList: function acceptList() {
      return ['enum'];
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (StringComponent);

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertSchemaToTree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(24);



function setNodeValue(node, schema, propertyList) {
  propertyList.forEach(function (property) {
    if (schema[property] || schema[property] === 0 || schema[property] === false) node.value[property] = schema[property];
  });
}

function convertStringToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].StringComponent();
  setNodeValue(node, schema, ['minLength', 'maxLength', 'pattern', 'format']);
  if (schema.enum) convertEnumToTree(node, schema.enum);
  tree.children.push(node);
}

function convertIntegerToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].IntegerComponent();
  setNodeValue(node, schema, ['multipleOf', 'minimum', 'exclusiveMinimum', 'maximum', 'exclusiveMaximum']);
  if (schema.enum) convertEnumToTree(node, schema.enum);
  tree.children.push(node);
}

function convertNumberToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].NumberComponent();
  setNodeValue(node, schema, ['multipleOf', 'minimum', 'exclusiveMinimum', 'maximum', 'exclusiveMaximum']);
  if (schema.enum) convertEnumToTree(node, schema.enum);
  tree.children.push(node);
}

function convertBooleanToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].BooleanComponent();
  tree.children.push(node);
}

function convertNullToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].NullComponent();
  tree.children.push(node);
}

function convertPropertiesToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].PropertiesComponent();
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(schema).forEach(function (p) {
    convertSubSchemaToTree(node, schema[p]);
    node.children[node.children.length - 1].name = p;
    node.children[node.children.length - 1].editable = true;
  });
  tree.children.push(node);
}

function convertRequiredToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].RequiredComponent();
  node.value = schema;
  tree.children.push(node);
}

function convertDependencyItemToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].DependencyItemComponent();
  node.value = schema;
  tree.children.push(node);
}

function convertDependenciesToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].DependenciesComponent();
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(schema).forEach(function (p) {
    convertDependencyItemToTree(node, schema[p]);
    node.children[node.children.length - 1].name = p;
  });
  tree.children.push(node);
}

function convertObjectToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].ObjectComponent();
  setNodeValue(node, schema, ['additionalProperties', 'minProperties', 'maxProperties']);
  if (schema.properties) convertPropertiesToTree(node, schema.properties);
  if (schema.required) convertRequiredToTree(node, schema.required);
  if (schema.dependencies) convertDependenciesToTree(node, schema.dependencies);
  if (schema.enum) convertEnumToTree(node, schema.enum);
  tree.children.push(node);
}

function convertItemsToTree(tree, schema) {
  if (Array.isArray(schema)) {
    var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].ItemsComponent();
    schema.forEach(function (s) {
      convertSubSchemaToTree(node, s);
    });
    tree.children.push(node);
  } else {
    convertSubSchemaToTree(tree, schema);
    tree.children[tree.children.length - 1].name = 'items';
  }
}

function convertArrayToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].ArrayComponent();
  setNodeValue(node, schema, ['additionalItems', 'minItems', 'maxItems', 'uniqueItems']);
  if (schema.items) convertItemsToTree(node, schema.items);
  tree.children.push(node);
}

function convertEnumToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].EnumComponent();
  node.value = {
    enum: schema
  };
  tree.children.push(node);
}

function convertEnumTypeToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].EnumComponent();
  node.value = schema;
  tree.children.push(node);
}

function convertAllOfToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].AllOfComponent();
  schema.forEach(function (s) {
    convertSubSchemaToTree(node, s);
  });
  tree.children.push(node);
}

function convertAnyOfToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].AnyOfComponent();
  schema.forEach(function (s) {
    convertSubSchemaToTree(node, s);
  });
  tree.children.push(node);
}

function convertOneOfToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].OneOfComponent();
  schema.forEach(function (s) {
    convertSubSchemaToTree(node, s);
  });
  tree.children.push(node);
}

function convertNotToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].NotComponent();
  schema.forEach(function (s) {
    convertSubSchemaToTree(node, s);
  });
  tree.children.push(node);
}

function convertRefToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].RefComponent();
  node.value['$ref'] = schema;
  tree.children.push(node);
}

function convertDefinitionsToTree(tree, schema) {
  var node = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].DefinitionsComponent();
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(schema).forEach(function (p) {
    convertSubSchemaToTree(node, schema[p]);
    node.children[node.children.length - 1].name = p;
    node.children[node.children.length - 1].editable = true;
  });
  tree.children.push(node);
}

function convertSubSchemaToTree(tree, schema) {
  if (schema.type) {
    switch (schema.type) {
      case 'string':
        return convertStringToTree(tree, schema);
      case 'integer':
        return convertIntegerToTree(tree, schema);
      case 'number':
        return convertNumberToTree(tree, schema);
      case 'boolean':
        return convertBooleanToTree(tree, schema);
      case 'null':
        return convertNullToTree(tree, schema);
      case 'object':
        return convertObjectToTree(tree, schema);
      case 'array':
        return convertArrayToTree(tree, schema);
    }
  }
  if (schema.enum) return convertEnumTypeToTree(tree, schema.enum);
  if (schema.allOf) return convertAllOfToTree(tree, schema.allOf);
  if (schema.anyOf) return convertAnyOfToTree(tree, schema.anyOf);
  if (schema.oneOf) return convertOneOfToTree(tree, schema.oneOf);
  if (schema.not) return convertNotToTree(tree, schema.not);
  if (schema['$ref']) return convertRefToTree(tree, schema['$ref']);
  if (schema.definitions) convertDefinitionsToTree(tree, schema.definitions);
}

function convertSchemaToTree(schema, name) {
  var tree = new __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */].JsonSchemaComponent();
  tree.name = schema.title || name;
  tree.tooltip = schema.description;
  tree.value.description = schema.description;
  convertSubSchemaToTree(tree, schema);
  return tree;
}

/* unused harmony default export */ var _unused_webpack_default_export = (convertSchemaToTree);

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menuData; });
var menuData = {
  menuItems: [{
    name: 'remove',
    label: 'Remove',
    disabled: function disabled(source) {
      return !source.node.parent;
    },
    action: function action(source) {
      source.remove();
    }
  }, {
    name: 'moveUp',
    label: 'Move Up',
    disabled: function disabled(source) {
      return !source.node.parent;
    },

    action: function action(source) {
      source.moveUp();
    }
  }, {
    name: 'moveDown',
    label: 'Move Down',
    disabled: function disabled(source) {
      return !source.node.parent;
    },

    action: function action(source) {
      source.moveDown();
    }
  }]
};

/* unused harmony default export */ var _unused_webpack_default_export = (menuData);

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RepositoryNotInitError */
/* unused harmony export SchemaNotExistError */
/* unused harmony export Repository */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return repository; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_json_schema_ref_parser__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_json_schema_ref_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_json_schema_ref_parser__);











function RepositoryNotInitError(message) {
  this.name = 'RepositoryNotInitError';
  this.message = message || 'Repository has not initialized.';
  this.stack = new Error().stack;
}
RepositoryNotInitError.prototype = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(Error.prototype);
RepositoryNotInitError.prototype.constructor = RepositoryNotInitError;

function SchemaNotExistError(message) {
  this.name = 'SchemaNotExistError';
  this.message = message || 'Schema not exist.';
  this.stack = new Error().stack;
}
SchemaNotExistError.prototype = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(Error.prototype);
SchemaNotExistError.prototype.constructor = SchemaNotExistError;

function EncodeSchema(schema) {
  var result = Array.isArray(schema) ? [] : {};
  for (var prop in schema) {
    var value = schema[prop];
    if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) === 'object') {
      result[encodeURIComponent(prop)] = EncodeSchema(value);
    } else {
      result[encodeURIComponent(prop)] = value;
    }
  }
  return result;
}

function DecodeSchema(schema) {
  var result = Array.isArray(schema) ? [] : {};
  for (var prop in schema) {
    var value = schema[prop];
    if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) === 'object') {
      result[decodeURIComponent(prop)] = DecodeSchema(value);
    } else {
      result[decodeURIComponent(prop)] = value;
    }
  }
  return result;
}

var Repository = function () {
  function Repository() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Repository);

    this.database = new __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* Database */]();
    this.uid = null;

    this.firebaseResolver = {
      order: 1,
      canRead: /^repository:/i,
      read: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(file) {
          var schemaName;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  schemaName = file.url.substr(13);
                  _context.next = 3;
                  return _this.retrieveSchema(schemaName, false);

                case 3:
                  return _context.abrupt('return', _context.sent);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function read(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    };
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Repository, [{
    key: 'init',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  if (__WEBPACK_IMPORTED_MODULE_7_firebase__["auth"]().currentUser) {
                    _this2.uid = __WEBPACK_IMPORTED_MODULE_7_firebase__["auth"]().currentUser.uid;
                    resolve();
                  } else {
                    reject(new __WEBPACK_IMPORTED_MODULE_8__firebase__["c" /* UserNotSignInError */]());
                  }
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _ref2.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: 'retrieveSchema',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(schemaName, dereference) {
        var reference, schema;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.uid) {
                  _context3.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid + '/' + schemaName;
                _context3.next = 5;
                return this.database.readValue(reference);

              case 5:
                schema = _context3.sent;

                if (!schema) {
                  _context3.next = 20;
                  break;
                }

                schema = DecodeSchema(schema);

                if (!(dereference || typeof dereference === 'undefined')) {
                  _context3.next = 17;
                  break;
                }

                _context3.prev = 9;
                _context3.next = 12;
                return __WEBPACK_IMPORTED_MODULE_9_json_schema_ref_parser___default.a.dereference(schema, { resolve: { firebase: this.firebaseResolver } });

              case 12:
                return _context3.abrupt('return', _context3.sent);

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](9);

              case 17:
                return _context3.abrupt('return', schema);

              case 20:
                throw new SchemaNotExistError();

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[9, 15]]);
      }));

      function retrieveSchema(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return retrieveSchema;
    }()
  }, {
    key: 'retrieveAllSchemas',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var reference, queryResult, schemas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.uid) {
                  _context4.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid;
                _context4.next = 5;
                return this.database.readSnapshot(reference);

              case 5:
                queryResult = _context4.sent;
                schemas = [];

                queryResult.forEach(function (item) {
                  schemas.push(DecodeSchema(item.val()));
                });
                return _context4.abrupt('return', schemas);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function retrieveAllSchemas() {
        return _ref4.apply(this, arguments);
      }

      return retrieveAllSchemas;
    }()
  }, {
    key: 'retrieveTypes',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var reference, types;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.uid) {
                  _context5.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid;
                _context5.next = 5;
                return this.database.list(reference);

              case 5:
                types = _context5.sent;
                return _context5.abrupt('return', types);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function retrieveTypes() {
        return _ref5.apply(this, arguments);
      }

      return retrieveTypes;
    }()
  }, {
    key: 'saveSchema',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(schema, schemaName) {
        var reference;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.uid) {
                  _context6.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid + '/' + schemaName;
                _context6.next = 5;
                return this.database.write(reference, EncodeSchema(schema));

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveSchema(_x4, _x5) {
        return _ref6.apply(this, arguments);
      }

      return saveSchema;
    }()
  }, {
    key: 'deleteSchema',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(schemaName) {
        var reference;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.uid) {
                  _context7.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid + '/' + schemaName;
                _context7.next = 5;
                return this.database.delete(reference);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteSchema(_x6) {
        return _ref7.apply(this, arguments);
      }

      return deleteSchema;
    }()
  }, {
    key: 'deleteAllSchemas',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var reference;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.uid) {
                  _context8.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid;
                _context8.next = 5;
                return this.database.delete(reference);

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteAllSchemas() {
        return _ref8.apply(this, arguments);
      }

      return deleteAllSchemas;
    }()
  }]);

  return Repository;
}();

var repository = new Repository();

/* unused harmony default export */ var _unused_webpack_default_export = (repository);

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return treeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(24);


var treeData = new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* default */].JsonSchemaComponent();

/* unused harmony default export */ var _unused_webpack_default_export = (treeData);

/***/ })

},[395]);


// WEBPACK FOOTER //
// static/js/nav.8071774a843a8a0befa4.js